module.exports = __webpack_public_path__ + "media/director_meetings/status_online-c97707c7.png";